import { render, staticRenderFns } from "./ItemAuthorStandardsMenu.vue?vue&type=template&id=0de94137&scoped=true"
import script from "./ItemAuthorStandardsMenu.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorStandardsMenu.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorStandardsMenu.vue?vue&type=style&index=0&id=0de94137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de94137",
  null
  
)

export default component.exports